<template>
  <div id="app">
    <Header />
    <main class="app-main">
      <router-view v-slot="{ Component, route }">
        <transition :name="transitionName" mode="out-in">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
    </main>
    <Footer />
    <PerformanceMonitor />
    <Toast ref="toastRef" />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Header, Footer, PerformanceMonitor, Toast } from '@/components/shared'
import { setToastInstance } from '@/composables/useToast'

const router = useRouter()
const transitionName = ref('fade')
const toastRef = ref(null)

// 设置全局 Toast 实例
onMounted(() => {
  if (toastRef.value) {
    setToastInstance(toastRef.value)
  }
})

// 根据路由变化选择不同的过渡动画
watch(
  () => router.currentRoute.value,
  (to, from) => {
    if (!from) {
      transitionName.value = 'fade'
      return
    }

    // 从首页到详情页使用 slide-left
    if (from.name === 'home' && to.name === 'toy') {
      transitionName.value = 'slide-left'
    }
    // 从详情页返回首页使用 slide-right
    else if (from.name === 'toy' && to.name === 'home') {
      transitionName.value = 'slide-right'
    }
    // 其他情况使用 fade
    else {
      transitionName.value = 'fade'
    }
  }
)
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 页面过渡动画 */
/* Fade 过渡 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Slide Left 过渡 */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease;
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* Slide Right 过渡 */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* 确保过渡期间的定位 */
.fade-enter-active > *,
.fade-leave-active > *,
.slide-left-enter-active > *,
.slide-left-leave-active > *,
.slide-right-enter-active > *,
.slide-right-leave-active > * {
  width: 100%;
}
</style>
